import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  height: auto;
  display: block;
  width: 100%;
  padding: 0 15px;
  max-width: 1270px;
  margin: 0 auto;
  @media (max-width: ${BP_TABLET_MAX}px) {
    padding: 0 26px;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    padding: 0 16px;
  }
`;
